:host {
  height: auto;
}

gz-dropdown {
  --form-field-input-width: 80px;
}

#miscellaneous-section {
  width: 870px;
}

gz-info-box {
  padding: calc(2 * var(--spacer)) 0 0;
  line-height: 18px;
  --info-box-max-width: 870px;
}

.info-box-style::part(container) {
  padding: unset;
  width: 870px;
}

#module-use-global-protective-network {
  padding-bottom: var(--spacer);
}

.form-field-input-misc-accordion {
  width: 455px;
  margin-top: calc(var(--spacer) * 1.5);
}

.submit-quarantine-hours-dropdown {
  display: inline;
}

.form-section {
  margin-top: calc(var(--spacer) * 2.5);

  .flex-group {
    display: flex;
    align-items: flex-start;

    .module-icon {
      margin-top: calc(var(--spacer) * 1.5);
      width: 39px;
      color: var(--chart-302-icon-buttons-titles);
    }
  }
}
